export default __webpack_public_path__ + "static/audio-console-2723867_1920-111b3cde75108df8f2555ecbf1ca7382.jpg";